import { productListLineStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import { css } from "styled-components";

productListLineStyles.quantityGridItem = {
    width: 6, printWidth: 6,
}

productListLineStyles.productQuantityOrderedStyles = {
    labelProps: {
        css: css`
            @media print {
                font-size: 12px;
            }
        `,
    },
    cssOverrides: {
        inputSelect: css`
            border: none;
            background: #fff;
            text-align: center;
            height: 27px;
            :focus {
                border: none;
            }
            @media print {
                width: 100px;
            }
        `,
    },
}